module.exports = __webpack_public_path__ + "img/2692.2cf7aa7.svg";